const DRIVER_CONSTANTS = {
  DRIVER_ASSIGNATION_ACTIONS: {
    DRIVER_REMOVED: 'driver_removed',
    DRIVER_CHANGED: 'driver_changed'
  },
  IS_RATING_AVAILABLE: false
}

export default DRIVER_CONSTANTS
